import React, { useState, useEffect } from "react";
import IsefcHeader from "../../components/Header/Isefc";
import IsefcFooter from "../../components/Footer/IsefcFooter";
import { BaseService } from "@/service";
import { checkResult } from "@/common";
import { useWatchState } from "@/store";
import { Icon, Button, Card, Divider, Row, Col, Popover, Carousel, Tooltip, Breadcrumb, List } from "antd";
import banner from "./images/banner.png";
import activityImg7 from "./images/activityImg7.png";
import activityImg8 from "./images/activityImg8.png";
import activityImg9 from "./images/activityImg9.png";
import banner_nav7 from "./images/banner_nav7.png";
import banner_nav8 from "./images/banner_nav8.png";
import banner_nav9 from "./images/banner_nav9.png";
import office from "./images/office.jpg";
import declaration from "./images/declaration.png";
import fileDown from "./images/fileDown.png";
import notice from "./images/notice.png";
import process from "./images/process.png";
import moment from "moment";
import "./style.less";


function Isefc({ history }) {
    const { Meta } = Card;
    let searchParams = new URLSearchParams(window.location.hash.split("isefc?")[1]);
    let idScreen = searchParams.get('screen');
    let idNum = searchParams.get('id');
    let identifyNum = searchParams.get('identify');
    let typeList = searchParams.get('type');
    const [[UPLOAD_SERVER_HOST = ""]] = useWatchState(["$_UPLOAD_SERVER_HOST"]);
    const [[IS_REGION], [{ IS_LOGIN, info }]] = useWatchState([
        "IS_REGION",
        "user",
    ]);
    console.log('IS_LOGIN', IS_LOGIN,   'user', info)

      if (IS_LOGIN) {
        localStorage.setItem("nickname", info.nickname);
        localStorage.setItem("account", info.account);
        localStorage.setItem("path_avatar", info.avatar);
        localStorage.setItem("IS_LOGIN", true);
      }

    /*从浏览器地址上获得参数改变banner的图片，其中动态新闻、通知公告、文件下载是用这个方式*/
    function banner_src(identifyNum) {
        switch (identifyNum) {
            case "1":
                return banner_nav7;
                break;
            case "2":
                return banner_nav8;
                break;
            case "3":
                return banner_nav9;
                break;
            case '':
                return null;
                break;
        }
    }

    /*取得不同类型的单条内容*/
    const [detail, setDetail] = useState('');
    const getDetail = idNum => {
        const res = BaseService.list({
            table: "thtt_project_news",
            where: { "id": idNum, "is_delete": 0, },
        }).then(res => {
            if (!checkResult(res)) return;
            setDetail(res.data.result[0])

        })
    }

    const [files, setFiles] = useState([]);
    const getFiles = idNum => {
        const res = BaseService.list({
            table: "thtt_attachment_relation",
            where: { "item_id": idNum, "is_delete": 0, },
        }).then(res => {
            if (!checkResult(res)) return;
            setFiles(res.data.result)
        })
    }
    useEffect(() => {
        if (idNum) { getDetail(idNum); getFiles(idNum) };
    }, [idNum]);

    const [identifyRes, setIdentifyRes] = useState([]);
    const [nominateRes, setNominateRes] = useState([]);
    const [selectedRes, setSelectedRes] = useState([]);

    const getIdentifyResList = async (identifyNum) => {
        if (identifyNum == 1 || identifyNum == 2 || identifyNum == 3) {
            const res = await BaseService.list({
                table: "thtt_project_news",
                where: { "identify": identifyNum, "is_delete": 0 },
                order: ["update_date Desc"]
            }).then(res => {
                if (!checkResult(res)) return;
                setIdentifyRes(res.data.result);
            })
        }
    }

    const getNominateResList = async (identifyNum) => {
        if (identifyNum == 4) {
            const res = await BaseService.list({
                table: "thtt_project",
                where: { "selected": 1, "is_delete": 0 },
                order: ["sort_date Desc"]
            }).then(res => {
                if (!checkResult(res)) return;
                setNominateRes(res.data.result);
            })
        }
    }


    const getSelectedResList = async (identifyNum) => {
        if (identifyNum == 5) {
            const res = await BaseService.list({
                table: "thtt_project",
                where: { "is_delete": 0 },
                order: ["sort_date Desc"]
            }).then(res => {
                if (!checkResult(res)) return;
                setSelectedRes(res.data.result);
            })
        }
    }

    useEffect(() => {
        if (identifyNum) getIdentifyResList(identifyNum); getNominateResList(identifyNum); getSelectedResList(identifyNum);
    }, [identifyNum]);

    const [orgRec, setOrgRec] = useState([]);
    const getOrgRecList = async () => {
        const res = await BaseService.list({
            table: "thtt_project_recommend",
            where: { "identify": 1, "is_delete": 0 },
            order: ["org_category Asc"]
        }).then(res => {
            setOrgRec(res.data.result)
        })
    }
    const [expertRec, setExpertRec] = useState([]);
    const getExpertRecList = async () => {
        const res = await BaseService.list({
            table: "thtt_project_recommend",
            where: { "identify": 3, "is_delete": 0 },
            order: ["duties Asc"]
        }).then(res => {
            setExpertRec(res.data.result)
        })
    }

    const [project_News, setProject_News] = useState([]);
    const getProject_NewsList = async () => {
        const res = await BaseService.list({
            table: "thtt_project_news",
            where: {
                "identify": 1,
                "is_delete": 0,
            },
            order: ["update_date Desc"],
        }).then(res => {
            setProject_News(res.data.result)
        })
    }

    const [project_Notice, setProject_Notice] = useState([]);
    const getProject_NoticeList = async () => {
        const res = await BaseService.list({
            table: "thtt_project_news",
            where: {
                "identify": 2,
                "is_delete": 0,
            },
            order: ["update_date Desc"]
        }).then(res => {
            setProject_Notice(res.data.result)
        })
    }

    const [project_DownFiles, setProject_DownFiles] = useState([]);
    const getProject_DownFilesList = async () => {
        const res = await BaseService.list({
            table: "thtt_project_news",
            where: {
                "identify": 3,
                "is_delete": 0,
            },
            order: ["update_date Desc"]
        }).then(res => {
            setProject_DownFiles(res.data.result)
        })
    }
    useEffect(() => { getOrgRecList(); getExpertRecList(); getProject_NewsList(); getProject_NoticeList(); getProject_DownFilesList(); }, [])

    function Category(Org_category) {
        switch (Org_category) {
            case 1:
                return ('科研院所');
            case 2:
                return ('大专院校');
            case 3:
                return ('专业学会');
            case 4:
                return ('行业协会');
            case 5:
                return ('央企/国企');
            case 6:
                return ('非公企业');
            case 7:
                return ('产业园区');
            case '':
                return null;
                break;
        }
    }

    function DutiesName(duties) {
        switch (duties) {

            case 1:
                return ('主任委员');
            case 2:
                return ('副主任委员');
            case 3:
                return ('特聘专家');
            case 4:
                return ('委员');
            case '':
                return null;
                break;
        }
    }



    function IdentifyName(identify) {
        switch (identify) {

            case "1":
                return ('动态新闻');
            case "2":
                return ('通知公告');
            case "3":
                return ('文件下载');
            case "4":
                return ('百优提名项目');
            case "5":
                return ('百优入围项目');

            case '':
                return null;
                break;
        }
    }

    function Content(photos, profile) {
        return (
            <div style={{ display: "flax", width: 480 }}>
                <Row>
                    <Col span={7} ><img alt="example" src={photos} /></Col>
                    <Col span={1} style={{ width: "1px", background: "#e8e8e8", height: "200px", marginLeft: 20 }}></Col>
                    <Col span={14} offset={1} >{profile}</Col>
                </Row>
            </div>)
    }

    return (
        <div>
            <IsefcHeader />
            {(idScreen !== "2") && (idScreen !== "3") && (idScreen !== "4") && (idScreen !== "5") && (idScreen !== "6") && (idScreen !== "7") && (idScreen !== "8") && (idScreen !== "9") &&
                <div className="home">
                    <div className="banner" style={{ backgroundImage: "none" }}>
                        <img src={banner} alt="banner" />
                    </div>
                    <div className="container">
                        <div class="entrance">
                            <a href="/#/isefcLogin?identity=application">
                                <div class="entrance-img entrance-img1" style={{ marginLeft: "0px" }}>
                                </div>
                            </a>
                            <a href="/#/isefcLogin?identity=recommendedUnit">
                                <div class="entrance-img entrance-img2">
                                </div>
                            </a>
                            <a href="/#/isefcLogin?identity=recommendedExpert">
                                <div class="entrance-img entrance-img3">
                                </div>
                            </a>
                            <a href="/#/isefcLogin?identity=judges">
                                <div class="entrance-img entrance-img4">
                                </div>
                            </a>
                            <div class="declare">
                                <a href="/#/isefc?screen=2"><img src={declaration} style={{ marginLeft: -2 }} /></a>
                                <div className="line"></div>
                                <a style={{ color: "#666" }} href={`/#/isefc?screen=7&type=list&identify=2`}><img src={notice} /></a>
                                <div className="line"></div>
                                <a style={{ color: "#666" }} href={`/#/isefc?screen=7&type=list&identify=3`}><img src={fileDown} /></a>
                            </div>
                        </div>
                    </div>
                    <IsefcFooter />
                </div>}
            {(idScreen == "2") && <div>
                <div className="home" style={{ marginBottom: 50 }}>
                    <div className="container" style={{ marginTop: "50px", paddingBottom: 50 }}>
                        <img src={process} alt="process" />
                    </div>
                    <IsefcFooter />
                </div>
            </div>}
            {(idScreen == "3") &&
                <div className="home" style={{ background: "#eeeeee", width: "100%" }}>
                    <div className="banner">
                        <span>推荐单位</span>
                    </div>
                    <div className="centerContent">
                        <div className="main_title">
                            双推双促首批拟邀请推荐单位名单(排名不分先后)
                        </div>
                        <div className="textContent"> <Divider><Icon type="crown" style={{ fontSize: '26px' }} /></Divider></div>
                        <div className="listContent">
                            <div className="main_title">
                                <Row>
                                    <Col span={4}>序号</Col>
                                    <Col span={16}>推荐单位名称</Col>
                                    <Col span={4}>机构类别</Col>
                                </Row>
                            </div>
                            <div>
                                {orgRec.map((item, i) => {
                                    return (
                                        <Row className="rowLine">
                                            <Col span={2} offset={2}>{i + 1}</Col>
                                            <Col span={11} offset={5}>{item.org_name}</Col>
                                            <Col span={3} offset={1}>{
                                                Category(item.org_category)
                                            }</Col>
                                        </Row>)
                                }
                                )}
                            </div>
                        </div>
                    </div>
                    <IsefcFooter />
                </div>
            }
            {
                (idScreen == "4") &&
                <div className="home" style={{ background: "#eeeeee", width: "100%" }}>
                    <div className="banner">
                        <span>专家委员会</span>
                    </div>
                    <div className="centerContent">
                        <div className="main_title">
                            专家(排名不分先后)
                        </div>
                        <div className="textContent"> <Divider><Icon type="crown" style={{ fontSize: '26px' }} /></Divider></div>
                        <div className="listContent" style={{ width: "1200px" }}>
                            <div className="main_title">
                                <Row>
                                    <Col span={3}>姓名</Col>
                                    <Col span={12}>单位</Col>
                                    <Col span={4}>领域背景</Col>
                                    <Col span={3} offset={2}>职务</Col>
                                </Row>
                            </div>
                            <div>
                                {expertRec.map((item) => {
                                    return (
                                        <Popover placement="topLeft" title={item.org_contacts_name} content={Content(item.photos, item.profile, item.sex)} arrowPointAtCenter>
                                            <Row className="rowLine14" >
                                                <Col span={2} offset={1}>{item.org_contacts_name}</Col>
                                                <Col span={11} offset={1}>{item.org_name}</Col>
                                                <Col span={4} offset={1}>{item.area}</Col>
                                                <Col span={3} offset={1} style={{ textAlign: "center" }}>{DutiesName(item.duties)}</Col>
                                            </Row>
                                        </Popover>)
                                }
                                )}
                            </div>
                        </div>
                    </div>
                    <IsefcFooter />
                </div>
            }
            {
                (idScreen == "5") &&
                <div className="home" style={{ background: "#eeeeee", width: "100%" }}>
                    < div className="public">
                        <div className="container public-content">
                            <div className="item" style={{ marginTop: 20 }} >
                                <ul>
                                    <div className="item-title">
                                        <div className="title-left">
                                            <Icon type="picture" theme="twoTone" style={{ marginTop: 10 }} />
                                            活动之窗
                                        </div>
                                    </div>
                                    <Carousel autoplay style={{ marginTop: 10 }} effect="fade" dotPosition="bottom">
                                        <div>
                                            <img src={activityImg9} />
                                            <h3>12月20日《双推双促工程》北京工业大学入围项目成果研讨会成功举办</h3>
                                        </div>
                                        <div>
                                            <img src={activityImg8} />
                                            <h3>12月18日优秀科技成果转化项目“双推双促工程”项目复审专家会议顺利进行</h3>
                                        </div>
                                        <div >
                                            <img src={activityImg7} style={{ width: 800 }} />
                                            <h3>8月28日科基会“双推双促工程”新质生产力（龙南）示范基地举行揭牌仪式</h3>
                                        </div>
                                    </Carousel>
                                </ul>
                            </div>
                            <div className="item" style={{ marginTop: 20 }}>
                                <ul>
                                    <div className="item-title">
                                        <div className="title-left">
                                            <Icon type="profile" theme="twoTone" style={{ marginTop: -5 }} />
                                            <a style={{ color: "#666" }} href={`/#/isefc?screen=7&type=list&identify=1`}>动态新闻</a>
                                        </div>
                                    </div>
                                    {project_News.slice(0, 5).map((item) => {
                                        const update_date = new Date(parseInt(item.update_date) * 1000);
                                        return (
                                            <li style={{ marginTop: 25, height: 20 }}>
                                                <div className="text">
                                                    <div className="dot"></div>
                                                    <Tooltip title={item.title}>
                                                        <span><a style={{ color: "#666", fontSize: 14, height: 25 }} href={`/#/isefc?screen=7&type=detail&id=${item.id}&identify=${item.identify}`}>{item.title.substring(0, 25)}</a><span style={{ float: "right", marginLeft: 5, color: "#999999" }}>{moment(update_date).format("YYYY-MM-DD")}</span></span>
                                                    </Tooltip>
                                                </div>
                                            </li>
                                        )
                                    })}
                                </ul>
                            </div>
                            <div className="public-item" style={{ marginTop: 5 }}>
                                <ul>
                                    <div className="item-title" >
                                        <div className="title-left">
                                            <Icon type="sound" theme="twoTone" style={{ marginTop: -5 }} />
                                            <a style={{ color: "#666" }} href={`/#/isefc?screen=7&type=list&identify=2`}>通知公告</a>
                                        </div>
                                        {/*<div className="title-right"><a>更多</a><Icon type="right" /> </div>*/}
                                    </div>
                                    {project_Notice.slice(0, 2).map((item) => {
                                        const update_date = new Date(parseInt(item.update_date) * 1000);
                                        return (
                                            <li>
                                                <div className="text">
                                                    <div className="dot"></div>
                                                    <span><a style={{ color: "#666" }} href={`/#/isefc?screen=7&type=detail&id=${item.id}&identify=${item.identify}`}>{item.title.substring(0, 25)}</a></span>
                                                </div>
                                                <div className="date">{moment(update_date).format("YYYY-MM-DD")}</div>
                                                <div className="line-botom"></div>
                                            </li>
                                        )
                                    }
                                    )}
                                </ul>
                            </div>
                            <div className="public-item">
                                <ul>
                                    <div className="item-title">
                                        <div className="title-left">
                                            <Icon type="cloud-download" />
                                            <a style={{ color: "#666" }} href={`/#/isefc?screen=7&type=list&identify=3`}>文件下载</a>
                                        </div>
                                    </div>
                                    <li>
                                        <div className="file">
                                            <div className="text">
                                                <div className="dot"></div>
                                                <Tooltip title="双推双促工程项目申报附件3:项目申报附件目录">
                                                    <span><a style={{ color: "#666", fontSize: 14, height: 25 }} href="http://211.149.135.84:8084/upload/images/20240412/附件3项目申报附件目录.pdf">"双推双促工程"项目申报附件3:项目申报附件目录</a></span>
                                                </Tooltip>
                                            </div>
                                            <Button type="primary" onClick={function () {
                                                window.open("http://211.149.135.84:8084/upload/images/20240412/附件3项目申报附件目录.pdf");
                                            }}>立即下载</Button>
                                        </div>
                                        <div className="date" style={{ marginTop: -13 }}>2024-04-12</div>
                                    </li>
                                    <li>
                                        <div className="file">
                                            <div className="text">
                                                <div className="dot"></div>
                                                <Tooltip title="双推双促工程项目网上申报操作办法">
                                                    <span><a style={{ color: "#666", fontSize: 14, height: 25 }} href="http://211.149.135.84:8084/upload/images/20240320/双推双促工程项目网上申报操作办法申报单位使用版.pdf">“双推双促工程”项目网上申报操作办法</a></span>
                                                </Tooltip>
                                            </div>
                                            <Button type="primary" onClick={function () {
                                                window.open("http://211.149.135.84:8084/upload/images/20240320/双推双促工程项目网上申报操作办法申报单位使用版.pdf");
                                            }}>立即下载</Button>
                                        </div>
                                        <div className="date" style={{ marginTop: -13 }}>2024-03-20</div>
                                    </li>

                                </ul>
                            </div>
                        </div>
                    </div>
                    <div className="center_footer" style={{ height: "135px" }}>
                        <footer className="p-isefc_footer">
                            <div className="p-isefc-center" style={{ marginTop: 30 }}>
                                <span>主办单位：中华国际科学交流基金会</span>
                                <span style={{ marginLeft: "91px" }}>咨询电话：010-88653180</span>
                                <span>咨询邮箱：stsc@isefc.org</span>
                            </div>
                            <div className="p-isefc-center">
                                <span>协办单位：中关村天合科技成果转化促进中心</span>
                                <span style={{ marginLeft: "33px" }}>咨询电话：010-88192046</span>
                                <span>咨询邮箱：thkj@techchina.org.cn</span>
                            </div>
                            <div className="p-isefc-center">
                                <span>技术支持：北京天合育成科技服务有限责任公司</span>
                                <span>备案号：京ICP备16027592号-3</span>
                            </div>
                        </footer>
                    </div>
                </div>
            }
            {
                (idScreen == "6") &&
                <div className="home">
                    <div className="banner">
                        <span>双推双促工程简介</span>
                    </div>
                    < div style={{
                        textAlign: "center", background: "#ffffff", display: "flex",
                        justifyContent: "center", fontSize: 40, marginTop: 0, marginBottom: 30,
                    }}>
                        <div className="center_title">
                            <Card
                                hoverable
                                style={{ width: 1200, textAlign: "left", marginTop: 10, border: "flase" }}
                            >
                                <Meta className="meta_text" description="为充分发挥中华国际科学交流基金会院士、杰出工程师等高端智力资源优势，探索以科技公益方式构建国家科技成果转化专业化及社会化服务体系，促进培育发展新质生产力，2024年科基会与和中关村天合科技成果转化促进中心共同组织发起科技成果转化“双推双促工程”（推成果、推需求、促转化、促落地），旨在破解科技成果转化“最后一公里”难题，促进推动科技成果向现实生产力高效转化，助力实现国家及地方实体经济高质量发展。" />
                                <Meta className="meta_text" description="“双推双促工程”锚定技术创新与产业创新深度融合目标，构建“入围-提名-优胜”三级筛选机制，致力于从海量科技成果中挖掘重大优秀科技成果转化项目。其中：“双推”为推成果（筛选优质技术）、推需求（对接产业与地方政府需求）；“双促”为促转化（专业赋能）、促落地（园区/资本对接）。" />
                                <Meta className="meta_text" description="“双推双促工程”的目标是发挥科技公益平台和专业化转化能力优势，发现和挖掘、促进和促成一批“中间态的优秀科技成果产业化落地项目”。“双推双促工程”的定位是形成“公益赋能+市场运作”双轮驱动模式，探索打造国家级科技成果转化生态赋能协同机制。“双推双促工程”的服务模式是全周期科技赋能，贯彻从项目遴选、技术评估、商业建模、融资对接、园区落地等全链条服务。" />
                                <Meta className="meta_text" description="科基会联合全国性重点行业协会、专业学会、高校、科研院所及院士、杰出工程师等多方力量组织实施“双推双促工程”，充分发挥各自资源优势，共同搭建起专业化、社会化的科技成果转化服务平台，推动项目落地生根，为各行业、各地区的科技成果产业化发展注入强劲动能。" />
                            </Card></div>
                    </div>
                    < div style={{
                        textAlign: "center", background: "#ffffff", display: "flex",
                        justifyContent: "center", fontSize: 40, marginTop: 50, marginBottom: 30,
                    }}>
                        <div className="center_title">双推双促工程组织架构
                            <Card
                                hoverable
                                style={{ width: 1200, textAlign: "left", marginTop: 50, border: "flase" }}
                            >
                                <Meta title="一、机构设置" />
                                <Divider />
                                <img src={office} alt="banner" style={{ marginTop: 50, marginBottom: 50, width: 1200 }}></img>
                            </Card></div>
                    </div>
                    <Card
                        hoverable
                        style={{ width: 1200, marginLeft: "auto", marginRight: "auto" }}
                    >
                        <Meta title="二、工程办公室管理团队" description="主  任：刘二东、朱楠" />
                        <Meta description="副主任：李猛、潘文龙、余军" style={{ marginTop: 20 }} />
                        <Meta description="成  员：辛妍、杨梅、周银芝、张悦、王晶晶" style={{ marginTop: 20 }} />
                    </Card>,
                    <Card
                        hoverable
                        style={{ width: 1200, marginLeft: "auto", marginRight: "auto", marginBottom: 80 }}
                    >
                        <Meta title="三、联系方式" description="北京市海淀区澄湾街19号院1号楼218室" />
                        <Meta description="联系人：杨梅，18701397959" style={{ marginTop: 20 }} />
                        <Meta description="北京市西城区月坛南街59号新华大厦508室" style={{ marginTop: 20 }} />
                        <Meta description="联系人：张悦，18301150902" style={{ marginTop: 20 }} />
                    </Card>
                    <IsefcFooter />
                </div>
            }
            {
                ((idScreen == "7") &&
                    <div className="home" style={{ background: "#eeeeee", width: "100%" }}>
                        <div className="banner">
                            <img src={banner_src(identifyNum)} alt="banner_nav" />
                        </div>
                        <div className="centerContent" style={{ background: "#eeeeee" }}>
                            <Breadcrumb>
                                <Breadcrumb.Item href="/#/isefc">
                                    <span>首页</span>
                                </Breadcrumb.Item>
                                <Breadcrumb.Item href={`/#/isefc?screen=7&type=list&identify=${identifyNum}`}>
                                    <span>{IdentifyName(identifyNum)}</span>
                                </Breadcrumb.Item>
                                <Breadcrumb.Item>{(typeList == "detail") ? detail.title : ''}</Breadcrumb.Item>
                            </Breadcrumb>
                        </div>
                        {(typeList == "detail") &&
                            <div className="centerContent">
                                <div className="main_title">{detail.title}</div>
                                <div className="subtitle">{moment(parseInt(detail.update_date) * 1000).format("YYYY-MM-DD HH:mm:ss")}</div>
                                <div style={{ marginLeft: 50, marginRight: 50 }} ><Divider /></div>
                                <div className="detail_content" dangerouslySetInnerHTML={{ __html: detail.profile }} />
                                {files.map((item, i) => {
                                    return (
                                        <Row className="rowLine">
                                            <Col span={15} offset={2}><a href={`http://${UPLOAD_SERVER_HOST}${item.file_path}`} style={{ color: "red" }} target="_blank">{item.file_name}</a></Col>
                                            <Col span={3} offset={1}><Button type="primary" onClick={function () {
                                                window.open(`http://${UPLOAD_SERVER_HOST}${item.file_path}`);
                                            }}>立即下载</Button></Col>
                                        </Row>)
                                }
                                )}
                            </div>
                        }
                        {(typeList == "list") &&
                            <div className="centerContent">
                                <div style={{ marginLeft: 50, marginRight: 50 }}>
                                    <List
                                        itemLayout="horizontal"
                                        dataSource={identifyRes}
                                        renderItem={item => (
                                            <List.Item>
                                                <List.Item.Meta
                                                    title={<a href={`/#/isefc?screen=7&type=detail&id=${item.id}&identify=${identifyNum}`}>{item.title}</a>}
                                                />
                                                <div>{moment(parseInt(item.update_date) * 1000).format("YYYY-MM-DD")}</div>
                                            </List.Item>
                                        )}
                                    />
                                </div>

                            </div>
                        }
                        <div style={{ height: 50 }}>&nbsp;</div>
                        <IsefcFooter style={{ marginTop: 30 }} />
                    </div>)
            }

        </div >
    )
}
export default Isefc;